import type { ReactNode } from 'react'
import { createContext, useContext } from 'react'

export type EnsureEnvelopeAccess = (options?: {
  rejected?: string
}) => Promise<string | null>

const resolveWithoutAccess: EnsureEnvelopeAccess = () => Promise.resolve(null)

const EnvelopeAccessContext =
  createContext<EnsureEnvelopeAccess>(resolveWithoutAccess)

export function EnvelopeAccessProvider({
  ensureToken,
  children,
}: {
  ensureToken: EnsureEnvelopeAccess
  children: ReactNode
}) {
  return (
    <EnvelopeAccessContext.Provider value={ensureToken}>
      {children}
    </EnvelopeAccessContext.Provider>
  )
}

export function useEnsureEnvelopeAccess(): EnsureEnvelopeAccess {
  return useContext(EnvelopeAccessContext)
}
